/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseVisitDto } from '../../models/response-visit-dto';

export interface VisitsControllerFindOne$Params {

/**
 * The tenant of the visit
 */
  tenant: string;

/**
 * The unique identifier of the visit
 */
  id: string;
}

export function visitsControllerFindOne(http: HttpClient, rootUrl: string, params: VisitsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseVisitDto>> {
  const rb = new RequestBuilder(rootUrl, visitsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseVisitDto>;
    })
  );
}

visitsControllerFindOne.PATH = '/thalea-pathways/visits/{tenant}/{id}';
